// import React, { useState } from "react";
// import { Box, Radio, RadioGroup, FormControlLabel } from "@mui/material";
// import BusinessWms from "../../businessPageData/businessWms/BusinessWms";
// import BusinessInnerChart1 from "./BusinessInnerChart1";
// import BusinessInnerChart2 from "./BusinessInnerChart2";
// import BusinessInnerChart3 from "./BusinessInnerChart3";

// export default function BusinessInnerChart() {
//   const [selectedTab, setSelectedTab] = useState("Monthly Yield");

//   const handleChange = (event) => {
//     setSelectedTab(event.target.value);
//   };

//   return (
//     <Box sx={{ width: "100%",height:"100%" }}>
//       {/* Radio Tabs Header */}
//       <RadioGroup
//         row
//         value={selectedTab}
//         onChange={handleChange}
//         sx={{ justifyContent: "start", mb: 2 }}
//       >
//         <FormControlLabel
//           value="Monthly Yield"
//           control={<Radio size="small" />}
//           label="Monthly Yield (kWh)"
//         />
//         <FormControlLabel
//           value="Today"
//           control={<Radio size="small" />}
//           label="Today"
//         />
//         <FormControlLabel
//           value="Plant Cumulative"
//           control={<Radio size="small" />}
//           label="Plant Cumulative"
//         />
//       </RadioGroup>

//       {/* Tab Content */}
//       <Box sx={{ mt: 2 }}>
//         {selectedTab === "Monthly Yield" && <BusinessInnerChart1/>}
//         {selectedTab === "Today" && <BusinessInnerChart2 />}
//         {selectedTab === "Plant Cumulative" && <BusinessInnerChart3/>}
//       </Box>
//     </Box>
//   );
// }


import React, { useState } from "react";
import { Box, Radio, RadioGroup, FormControlLabel } from "@mui/material";
import BusinessWms from "../../businessPageData/businessWms/BusinessWms";
import BusinessInnerChart1 from "./BusinessInnerChart1";
import BusinessInnerChart2 from "./BusinessInnerChart2";
import BusinessInnerChart3 from "./BusinessInnerChart3";
import BusinessInnerChart4 from "./BusinessInnerChart4";

export default function BusinessInnerChart() {
  const [selectedTab, setSelectedTab] = useState("Monthly Yield");

  const handleChange = (event) => {
    setSelectedTab(event.target.value);
  };

  return (
    <Box sx={{ width: "100%",height:"100%" }}>
      {/* Radio Tabs Header */}
      <RadioGroup
        row
        value={selectedTab}
        onChange={handleChange}
        sx={{ justifyContent: "start", mb: 2 }}
      >
        <FormControlLabel
          value="Monthly Yield"
          control={<Radio size="small" />}
          label="Todays KWh Vs. Todays CUF "
        />
        <FormControlLabel
          value="Today"
          control={<Radio size="small" />}
          label="Todays KWh Vs. Todays PR"
        />
        <FormControlLabel
          value="Plant Cumulative"
          control={<Radio size="small" />}
          label="Todays PR Vs. Todays CUF"
        />
        <FormControlLabel
          value="Todays Specific Yield"
          control={<Radio size="small" />}
          label="Todays Specific Yield"
        />
      </RadioGroup>

      {/* Tab Content */}
      <Box sx={{ mt: 2 }}>
        {selectedTab === "Monthly Yield" && <BusinessInnerChart1/>}
        {selectedTab === "Today" && <BusinessInnerChart2 />}
        {selectedTab === "Plant Cumulative" && <BusinessInnerChart3/>}
        {selectedTab === "Todays Specific Yield" && <BusinessInnerChart4/>}
      </Box>
    </Box>
  );
}
